import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const ReferralDistributionContent = ({data}) => {

    useEffect(() => {
        const values = [];
        const labels = [];

        data.referralDistribution.forEach((el) => {
            labels.push(el.referral);
            values.push(el.amount);
        });

        GraphicUtils.barChart("referralDistribution", values.slice(0, 15), labels.slice(0, 15), false);
        ReportUtils.createExportableTable(labels, values, 'Encaminhamento dos indivíduos');
    }, []);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title mb-2">Encaminhamento de indivíduos {data.referralDistribution.length >= 15 ? ' (TOP 15)' : ''}</span>
                <div id="referralDistribution"></div>
            </div>
        </>
    );
};

export default ReferralDistributionContent;